/* Gymatics: Track your order. Lookup by order number + email or postcode, live refresh, countdown, confetti. */
(function () {
  var root = document.querySelector('[data-gt]');
  if (!root) return;

  /* chalk dust in the hero */
  var dust = root.querySelector('.gt-chalk');
  if (dust && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    for (var i = 0; i < 18; i++) {
      var d = document.createElement('i');
      d.style.cssText = '--x:' + Math.round(Math.random() * 100) + '%;--s:' + (3 + Math.random() * 7).toFixed(1) + 'px;--d:' + (7 + Math.random() * 8).toFixed(1) + 's;--w:-' + (Math.random() * 12).toFixed(1) + 's;--dx:' + Math.round(Math.random() * 80 - 40) + 'px';
      dust.appendChild(d);
    }
  }

  /* the lookup: order number + (email or postcode) -> private code, same recipe as the Gymatics Workshop */
  var form = root.querySelector('#gt-form');
  if (form) {
    var q = new URLSearchParams(location.search), pre = q.get('order') || q.get('o');
    if (pre) form.order.value = pre;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = root.querySelector('#gt-err'), num = (form.order.value || '').replace(/\D/g, ''), who = (form.who.value || '').trim();
      var show = function (t, f) { err.textContent = t; err.hidden = false; f.focus(); };
      if (!num) return show('Type your order number, e.g. 2587.', form.order);
      var key;
      if (who.indexOf('@') > 0) key = who.toLowerCase();
      else if (/^[a-z0-9 ]{3,10}$/i.test(who.replace(/\s+/g, ''))) key = 'pc:' + who.toLowerCase().replace(/[^a-z0-9]/g, '');
      else return show('Type the email you ordered with, or your delivery postcode.', form.who);
      err.hidden = true;
      var btn = form.querySelector('button'); btn.disabled = true; btn.innerHTML = '<span class="gt-spin"></span> Finding your order...';
      crypto.subtle.digest('SHA-256', new TextEncoder().encode(key + '|' + num)).then(function (buf) {
        var hex = Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('').slice(0, 40);
        location.href = root.dataset.search + '?view=track-order&type=page&q=' + hex;
      });
    });
  }

  /* "ready in about ..." from the Workshop's estimate */
  var ready = root.querySelector('[data-ready]');
  if (ready) {
    var t = new Date(ready.dataset.ready), mins = Math.round((t - new Date()) / 60000), out = ready.querySelector('b');
    if (mins <= 20) out.textContent = 'Any minute now';
    else if (mins < 90) out.textContent = 'In about ' + Math.round(mins / 5) * 5 + ' minutes';
    else if (mins < 60 * 20) out.textContent = 'In about ' + Math.round(mins / 60) + ' hours';
    else { var r = new Date(t.getTime() + 30 * 60000); out.textContent = t.toLocaleDateString('en-GB', {weekday: 'long', day: 'numeric', month: 'short'}) + ', around ' + r.toLocaleTimeString('en-GB', {hour: 'numeric', hour12: true}).replace(/\s/g, '').toLowerCase(); }
  }

  /* copy the tracking number */
  var copy = root.querySelector('[data-copy]');
  if (copy) copy.addEventListener('click', function () {
    navigator.clipboard.writeText(copy.dataset.copy).then(function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy'; }, 1800); });
  });

  /* live: refresh every 2 minutes while the page is open and visible */
  if (root.dataset.live) setInterval(function () { if (!document.hidden) location.reload(); }, 120000);

  /* confetti once, when it's on its way */
  if (root.dataset.posted && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var seen = 'gt-confetti-' + root.dataset.posted;
    try { if (sessionStorage.getItem(seen)) return; sessionStorage.setItem(seen, 1); } catch (e) {}
    var c = document.createElement('canvas'); c.className = 'gt-confetti'; document.body.appendChild(c);
    var x = c.getContext('2d'), W = c.width = innerWidth, H = c.height = innerHeight, cols = ['#FF7200', '#023F90', '#FFB27A', '#2F7BEA', '#3EE089', '#F2378A'];
    var bits = Array.from({length: 140}, function () { return {x: W / 2 + (Math.random() - .5) * 200, y: H * .35, vx: (Math.random() - .5) * 14, vy: -Math.random() * 14 - 4, r: Math.random() * 6 + 4, a: Math.random() * 6, c: cols[Math.floor(Math.random() * cols.length)]}; });
    var start = performance.now();
    (function frame(now) {
      x.clearRect(0, 0, W, H);
      bits.forEach(function (b) { b.vy += .35; b.x += b.vx; b.y += b.vy; b.a += .15; x.save(); x.translate(b.x, b.y); x.rotate(b.a); x.fillStyle = b.c; x.fillRect(-b.r / 2, -b.r / 4, b.r, b.r / 2); x.restore(); });
      if (now - start < 3500) requestAnimationFrame(frame); else c.remove();
    })(start);
  }
})();
